import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '../fetchBaseQuery';
import type {
    AnalyticsTrialRequest,
    AnalyticsTrialStatusRawResponse,
    AnalyticsTrialStatusResponse,
    UpdateFilterSelectionRequest,
} from './types';

export const analyticsApi = createApi({
    reducerPath: 'analytics',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['trialStatus'],
    endpoints: (builder) => ({
        advancedFiltersTrialStatus: builder.query<AnalyticsTrialStatusResponse, AnalyticsTrialRequest>({
            query: ({ teamId }) => ({
                method: 'GET',
                url: `/analytics-trial/${teamId}`,
            }),
            providesTags: ['trialStatus'],
            transformResponse: (response: AnalyticsTrialStatusRawResponse): AnalyticsTrialStatusResponse => ({
                status: response.status,
                expiresAt: response.expires_at,
            }),
        }),
        updateFilterSelection: builder.mutation<void, UpdateFilterSelectionRequest>({
            query: ({ data, report }) => ({
                method: 'POST',
                url: `/analytics/filters/${report}`,
                body: data,
            }),
        }),
        enableAdvancedFiltersTrial: builder.mutation<void, AnalyticsTrialRequest>({
            query: ({ teamId }) => ({
                method: 'POST',
                url: `/analytics-trial/${teamId}`,
            }),
            invalidatesTags: ['trialStatus'],
        }),
    }),
});

export const {
    useUpdateFilterSelectionMutation,
    useEnableAdvancedFiltersTrialMutation,
    useAdvancedFiltersTrialStatusQuery,
} = analyticsApi;

export { MetabaseAnalyticsPageReportNames, type MetabaseAnalyticsPageReportName } from './types';
